import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, keywords }) => {
  return (
    <Helmet>
      <title>{title ? `${title} | SSS Home Painting Madurai` : 'SSS Home Painting Madurai | Top Rated Painting Services'}</title>
      <meta name="description" content={description || "Professional home painting services in Madurai. 16+ years of experience in interior and exterior painting, wood polishing, and waterproofing."} />
      <meta name="keywords" content={keywords || "painting services Madurai, home painters Madurai, SSS Home Painting, interior painting Madurai, exterior painting Madurai"} />
      <meta property="og:title" content={title || "SSS Home Painting Madurai"} />
      <meta property="og:description" content={description || "Professional home painting services in Madurai."} />
      <meta property="og:type" content="website" />
      <link rel="canonical" href={window.location.href} />
    </Helmet>
  );
};

export default SEO;
